export default __webpack_public_path__ + "static/media/configr-custom-horizontal.eb954316.svg";